module.exports = __webpack_public_path__ + "img/chazhao.aa905f6e.png";